// Runtime env resolver. Order:
//   1. window.__ENV[key]   -> populated by /env-config.js at container start
//   2. import.meta.env[key] -> Vite-bundled env (.env files, VITE_* prefixed)
//   3. defaultValue
//
// Both REACT_APP_<KEY> (legacy) and VITE_<KEY> are accepted in Vite env.

export const getEnv = (key: string, defaultValue: string = ""): string => {
  if (
    typeof window !== "undefined" &&
    (window as any).__ENV &&
    (window as any).__ENV[key] !== undefined &&
    (window as any).__ENV[key] !== ""
  ) {
    return (window as any).__ENV[key];
  }

  const meta = (import.meta as any).env || {};
  const fromMeta = meta[key];
  if (fromMeta !== undefined && fromMeta !== "") {
    return fromMeta;
  }

  // Fallback to a VITE_ prefixed variant if caller used the REACT_APP_ name.
  if (key.startsWith("REACT_APP_")) {
    const viteKey = "VITE_" + key.slice("REACT_APP_".length);
    const fromVite = meta[viteKey];
    if (fromVite !== undefined && fromVite !== "") {
      return fromVite;
    }
  }

  return defaultValue;
};
